<template>
  <div class="Forum">
    <!--  轮播-->
    <div class="swiper">
      <el-row>

        <el-col :span="12" style="padding-right: 15rem">
          <h3>用户交流论坛<br/>分享你的见解</h3>
          <h5>
            在这里交流经验、解决问题、共同成长
          </h5>
        </el-col>
        <el-col :span="12">
          <img src="../../../assets/Yuncang/Yuncang1.png" width="100%">
        </el-col>
      </el-row>
    </div>
    <!-- 操作区：搜索 + 发布按钮 -->
    <div class="wrap">

      <el-form
          :inline="true"
          ref="searchForm"
          :model="searchForm"
          @keyup.enter="searchForumList()"
          style="display: flex; align-items: center; flex-wrap: wrap;"
      >
        <el-form-item prop="title" label="帖子标题：">
          <el-input
              placeholder="输入帖子标题"
              v-model="searchForm.title"
              clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="authorName" label="发帖人：">
          <el-input
              placeholder="输入发帖人"
              v-model="searchForm.authorName"
              clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="custom-button search-button" @click="searchForumList()">查询</el-button>
          <el-button class="custom-button reset-button" @click="resetSearchForm()">重置</el-button>
        </el-form-item>
<!--        <el-form-item style="margin-left: auto;">-->
<!--          <el-button type="primary" @click="goToCreate">-->
<!--            发布新帖-->
<!--          </el-button>-->
<!--        </el-form-item>-->
      </el-form>
      <!-- 帖子列表区 -->
      <div class="PostList">
        <div class="list" v-for="item in postList" :key="item.id" @click="jumpToDetail(item.id)">
          <div v-if="item.isTop === 1" class="sticky-tag">
            置顶
          </div>
          <div class="tetxbox">
            <div class="name">{{item.title}}</div>
            <div class="text">{{item.introduction}}</div>
            <div class="info">
              <div style="display: flex; align-items: center; gap: 1rem;">
                <div><i style="margin-right: 1rem">{{item.authorName}}</i></div>
                <div><i style="margin-right: 1rem">{{item.createTime}}</i></div>
              </div>
              <div style="display: flex; align-items: center; gap: 1rem;">
                <div style="display: flex; align-items: center;font-size: 2.5rem">
                  <el-icon size="30"><View /></el-icon>
                  <span>{{item.viewCount}}</span>
                </div>
                <div style="display: flex; align-items: center;font-size: 2.5rem">
                  <el-icon size="30"><ChatDotRound /></el-icon>
                  <span>{{item.commentCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: center;width: 100%;">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, total"
            :total=total
            style="text-align: center; margin-top: 10rem;font-size: 2rem">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import newService from "@/api/newService";
import { View, ChatDotRound } from '@element-plus/icons-vue'

export default {
  name: "ForumIndex",
  components: {ChatDotRound, View},
  created() {

  },
  data(){
    return {
      postList:[],
      searchForm:{
        title:'',
        authorName:''
      },
      total:0,
      pageNum:1,
      pageSize:8,
    }
  },
  mounted() {
    this.getForumList();
  },
  methods:{
    handleCurrentChange(val) {
      this.pageNum=val;//当前页
      this.getForumList();
    },
    handleSizeChange(val) {
      this.pageSize=val;//当前页
      this.getForumList();
    },
    getForumList(){
      var obj={
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        title:this.searchForm.title,
        authorName:this.searchForm.authorName,
      }
      newService.getForumList(obj)
          .then(res=>{
            const resStr = String(res);
            if (resStr.includes("错误^/^")) {
              const parts = resStr.split(':');
              let errorMessage = '';
              if (parts.length >= 2) {
                errorMessage = parts.slice(1).join(':').trim();
              } else {
                errorMessage = resStr;
              }
              this.$message.error(errorMessage)
            }else {
              this.postList=res.records
              this.total=res.total
            }
          })
    },
    goToCreate(){

    },
    searchForumList(){
      this.getForumList();
    },
    resetSearchForm(){
      this.searchForm={
        title:'',
        authorName:''
      }
      this.pageNum=1;
      this.pageSize=10;
      this.getForumList();
    },
    jumpToDetail(id){
      localStorage.setItem('forumId',id)
      this.$store.state.components='forum1'
      this.$store.state.isbackground=true
      this.$store.state.iscolor=true
      this.$store.state.islogored=true
      document.body.scrollTop=document.documentElement.scrollTop=0
    },
  }

}
</script>

<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).is-active{
  background: #FFEDEF;border-radius: 6px;color: #FF0B41;
}
.swiper{
  width: 100%;
  background: url('../../../assets/Yuncang/Yuncang1bg.png') no-repeat; background-size: 100% 100%;
  .el-row{
    width: 120rem;
    min-width: 120rem;
    padding: 12rem 0 10rem;
    margin: auto;
    text-align: left;
    h3{

      margin-top: 10rem;
      font-size: 5rem;
      margin-bottom: 2rem;
    }
    h5{
      font-size: 2rem;
      font-weight: 400;
      color: #444955;
      line-height: 40px;
    }
  }
}
.Forum{
  padding-top: 0rem;
}
.wrap{
  width: 120.0rem;
  min-width: 120rem;
  padding:4.0rem 0 16rem;
  margin: auto;
  .name{
    font-size: 4.0rem;
    color: #000;
    text-align: center;
    margin-bottom: 10rem;
  }
  // 在样式部分添加以下代码
  /deep/ .custom-button {
    border-radius: 1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    padding: 1.3rem 2.6rem;
    font-size: 1.5rem;
  }

  /deep/ .search-button {
    background: linear-gradient(to right, #ff0b41, #ff5252);
    border: none;
    color: white;
    box-shadow: 0 4px 12px rgba(255, 11, 65, 0.3);

    &:hover {
      background: linear-gradient(to right, #e00a3b, #e94a4a);
      transform: translateY(-2px);
      box-shadow: 0 6px 15px rgba(255, 11, 65, 0.4);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(255, 11, 65, 0.3);
    }
  }
  /deep/ .reset-button {
    background: white;
    border: 1px solid #ff0b41;
    color: #ff0b41;

    &:hover {
      background: #ffeeee;
      color: #e00a3b;
      border-color: #e00a3b;
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
// 帖子列表样式
.PostList{
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem 0;
  .list{
    // 新增：为了让置顶标记能相对卡片定位
    position: relative;

    // 置顶标记样式
    .sticky-tag{
      position: absolute;
      top: 0;
      right: 0;
      background-color: #FF0B41; // 醒目红色背景
      color: white; // 白色文字
      font-size: 1.6rem;
      padding: 0.5rem 1.2rem;
      border-radius: 0 0 0 0.6rem; // 左下角圆角
      font-weight: bold;
      z-index: 1; // 确保在卡片内容上方显示
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    width: 100%; /* 宽度占满容器 */
    height: auto; /* 高度自适应 */
    margin-bottom: 2rem; /* 增加底部间距 */
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0rem .3rem 1.2rem 0rem rgba(0,0,0,0.12);
    border-radius: .6rem;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      img{
        transform: scale(1.15);

      }
      box-shadow: 0rem .3rem 1.2rem 0rem rgba(0,0,0,0.5);
    }
    .tetxbox{
      width: 100%;
      padding: 1.4rem;
      .name{
        font-size: 2.0rem;
        color: #333;
        margin-bottom: 1.2rem;
        text-align: left;
        font-weight: 550;
      }
      .text{
        overflow: hidden; //超出的文本隐藏
        font-size: 1.4rem;
        text-overflow: ellipsis; //溢出用省略号显示
        font-weight: 400;
        display: -webkit-box;
        color: #444955;
        -webkit-line-clamp: 1; // 超出多少行
        line-height: 2.2rem;
        -webkit-box-orient: vertical;
      }
    }
    .info{
      display: flex;
      justify-content: space-between;
      font-size: 1.5rem;
      margin-top: 2.0rem;
      color: #FF0B41;
      i{
        font-size: 1.5rem;
        font-style: normal;
        color: #FF0B41;
      }
    }
  }
}


</style>
